<template>
    <div class="pg-answer">
        <div v-if="step === 1" class="step1" :class="{
          'with-bg': baseStyle && (baseStyle.bgSrc || baseStyle.color),
          horizontal: isHorizontal
        }" :style="style">
          <div class="survey_cover_text">
              <div class="TopBgTitle">
                  <p style="text-align: left;">{{base.title}}</p>
              </div>
              <div class="desc_begin" v-html="base.desc"></div>
          </div>
          <div class="submmit" @click="step = 2">开始填写</div>
        </div>
        <div v-else class="container"
            :style="{background: baseStyle && (baseStyle.bgSrc || baseStyle.color) && baseStyle.opacity ? 'rgba(255, 255, 255, ' + baseStyle.opacity/100 + ')' : ''}">
            <img :src="baseStyle.header" class="header_img" width="100%" v-if="baseStyle && baseStyle.header">
            <div class="progress">
                <div class="progress-bar s-prog-wait" ref="progress">
                    <div class="progress-done s-prog-done" :style="{width: width + '%'}"></div>
                </div>
            </div>
            <div class="survey_cover_text">
                <div class="user" v-if="base.logintype == 1 && account">
                    <span class="username">欢迎您，{{account}}</span>
                    <a @click="showConfirm = true" href="javascript:void(0)">注销</a>
                </div>
            </div>
            <div class="questions">
                <QuestionMobile
                    :data="item"
                    v-on:itemClick="itemOnClick"
                    v-on:contentUpdate="contentOnUpdate"
                    v-on:itemContentUpdate="itemContentUpdate"
                    v-for="(item, index) in questions"
                    :textColor="style.color || ''"
                    :optionColor="baseStyle.optionColor"
                    :optionHighlightColor="baseStyle.optionHighlightColor"
                    :key="index"
                    :sort="index + 1"
                ></QuestionMobile>
            </div>
            <div class="submmit" @click="submit()">提交</div>
            <div class="tail"></div>
        </div>
        <ModalMask :show="showConfirm"></ModalMask>
        <Modal v-if="showConfirm">
            <confirm msg="确认要登出吗" v-on:close="showConfirm = false" v-on:confirm="confirm"></confirm>
        </Modal>
        <alert ref="alert"></alert>
    </div>
</template>
<script>
  import * as types from '~/store/mutation-type';
  import store from '~/store/index';
//   import Footer from '~/components/Footer/footer.vue';
  import QuestionMobile from '~/components/QuestionMobile/question.vue';
  import api from '~/api/api';
  import { getParameterByName, rem, redirectTo, isMobile, getUrlParams } from '~/tools/utils';
  import Mask from '~/components/Mask/mask.vue';
  import Modal from '~/components/Modal/modal.vue';
  import confirm from '~/components/confirm.vue';
  import DeviceDetector from "device-detector-js";
  import alert from '~/components/alert.vue';

  export default {
    components: {
        QuestionMobile,
        ModalMask: Mask,
        Modal,
        confirm,
        alert
    },
    data () {
        return {
          step: 1,
          isHorizontal: window.innerWidth > window.innerHeight,
          isInIFrame: getParameterByName('iframe'),
          questions: null,
          showConfirm: false,
          base: {
            style: {}
          },
          baseStyle: {},
          style: {},
          account: '',
          glogin: null,
          showLogin: false,
          starttime: null
        }
    },
    computed: {
      width() {
          let val = this.finished*100/this.questionNum;
          console.log(val)
          return val
      },
      questionNum() {
          return this.questions ? this.questions.length : 1
      },
      finished() {
        let finishedAccount = 0;
        if(!this.questions) return 0
        for (let index = 0; index < this.questions.length; index++) {
            const element = this.questions[index];
            if(/^[1|4|5]/.test(element.qtype)) {
                let matchedIndex = element.options.findIndex(item => item.selected);
                // remark为包含填空
                if(matchedIndex >= 0 && (element.options[matchedIndex].remark != 1 || (element.options[matchedIndex].remark == 1 &&
                  (element.options[matchedIndex].content_required != 1 || (element.options[matchedIndex].content_required == 1 && element.options[matchedIndex].text))
                ))) {
                  finishedAccount++;
                }
            } else if(/^2/.test(element.qtype)) {
              let matchedItems = element.options.filter(item => item.selected);
              if(matchedItems.length && matchedItems.every(x => x.remark != 1 || (x.remark == 1 && (x.content_required != 1 || (x.content_required == 1 && x.text)) ))) {
                  finishedAccount++;
              }
            } else if(/^6/.test(element.qtype)) {
              if(element.rows.every(x => x.val >= 0)) {
                  finishedAccount++;
              }
            } else if(element.content) {
                finishedAccount++;
            }
        }
        return finishedAccount
      }
    },
    mounted() {
        let _this = this;
        if(!isMobile()) {
            let addr = location.href.split("#")
            location.replace(`${addr[0]}#/site${addr[1]}`)
        }
        rem();
        window.addEventListener('message', event => {
            console.log('postMessage' + JSON.stringify(event.data));
            if(event.data == 'refresh') {
                this.init();
            }
        });

        // this.init().then(res => {
        //   if(!this.isInIFrame && process.env.VUE_APP_ENV !== 'development') {
        //     requirejs(['login/index'], gLogin => {
        //         _this.glogin = new gLogin({
        //             type:'popup',
        //             //设置 去注册按钮
        //             fastreg:{
        //                 //注意：不支持回调函数
        //                 type: 'normal'
        //             },
        //             login_type: 27,
        //             onLogin: function(result) {
        //                 if(result){
        //                     //登录成功
        //                     api.login({
        //                         sid: _this.$route.params.sid
        //                     }).then(res => {
        //                         if(!res) return;
        //                         _this.account = res.data.account;
        //                         if(res.replycount == 1) {
        //                             store.commit(types.SHOW_MODAL, {name: 'message', msg: '您已参加过该问卷调查哦，感谢您的参与~'});
        //                         }
        //                     });
        //                 } else{
        //                     //登录失败
        //                     store.commit(types.SHOW_MODAL, {name: 'message', msg: result.msg});
        //                 }
        //             },
        //             onLogout:function(result){
        //                 if(!!result&&!!result.status&&result.status>0){
        //                     //注销成功
        //                 }
        //                 else{
        //                     //注销失败
        //                     store.commit(types.SHOW_MODAL, {name: 'message', msg: result.msg});
        //                 }
        //             }
        //         });
        //     });
        //   }
        // });
        Promise.all([
          this.init(),
          this.initLogin()
        ]).then(res => {
          if(this.base.logintype == 1 && !this.account) {
            this.glogin.login();
          }
        })
    },
    // watch: {
    //     glogin(val) {
    //         if(this.base.logintype == 1 && !this.account) {
    //             val.login();
    //         }
    //     }
    // },
    methods: {
      initLogin() {
        return new Promise((resolve, reject) => {
          let _this = this;
          if(!this.isInIFrame && process.env.VUE_APP_ENV !== 'development') {
            requirejs(['login/index'], gLogin => {
              _this.glogin = new gLogin({
                  type:'popup',
                  //设置 去注册按钮
                  fastreg:{
                      //注意：不支持回调函数
                      type: 'normal'
                  },
                  login_type: 27,
                  onLogin: function(result) {
                      if(result){
                          //登录成功
                          api.login({
                              sid: _this.$route.params.sid
                          }).then(res => {
                              if(!res) return;
                              _this.account = res.data.account;
                              if(res.replycount == 1) {
                                  store.commit(types.SHOW_MODAL, {name: 'message', msg: '您已参加过该问卷调查哦，感谢您的参与~'});
                              }
                          });
                      } else{
                          //登录失败
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: result.msg});
                      }
                  },
                  onLogout:function(result){
                      if(!!result&&!!result.status&&result.status>0){
                          //注销成功
                      }
                      else{
                          //注销失败
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: result.msg});
                      }
                  }
              });
              resolve()
            });
          } else {
            resolve()
          }
        })
      },
      shuffle(arr) {
        var len = arr.length;
        for(var i=0;i<len;i++){
            var end = len - 1 ;
            var index = (Math.random()*(end + 1)) >> 0;
            var t = arr[end];
            arr[end] = arr[index];
            arr[index] = t;
        }
        return arr;
      },
      confirm() {
          api.logout(this.$route.params.sid).then(res => {
              this.showConfirm = false;
              if(!res) return;
              this.account = '';
              if(!this.isInIFrame && this.base.logintype == 1) {
                  this.glogin.login();
              }
          }).catch(() => {
              this.showConfirm = false;
          });
      },
      groupByValues(arr, key1, key2) {
        return arr.reduce((result, current) => {
            const groupKey = current[key1] + ':' + current[key2];
            if (!result[groupKey]) {
            result[groupKey] = [];
            }
            result[groupKey].push(current);
            return result;
        }, {});
      },
      async init() {
          let _this = this;
          try {
            let res = await api.getInfo(this.$route.params.sid);
            if(!res) return;
            if(res.data.unorder == 1) {
                _this.questionsAll = _this.shuffle(JSON.parse(JSON.stringify(res.question)));
            } else {
                _this.questionsAll = JSON.parse(JSON.stringify(res.question));
            }
            _this.questionsAll = _this.questionsAll.map(x => {
                if(x.qtype == 2 && x.unorder == 1) {
                    x.options = _this.shuffle(JSON.parse(JSON.stringify(x.options)));
                }
                return x;
            });
            res.data.desc = res.data.desc.replace(/\n/g, "<br/>")
            _this.base = Object.assign({}, res.data);
            _this.baseStyle = Object.assign({}, res.data.style);

            const groupedByAge = this.groupByValues(res.logics, 'qid', 'target_qid');
            var result = []
            for (const key in groupedByAge) {
                var qoid = groupedByAge[key].map(item => item.qoid).join(',');
                result.push(Object.assign(groupedByAge[key][0], {qoid}))
            }
            _this.logics = result;
          //   if(_this.logics.length > 0) {
          //     let target_qid_arr = _this.logics.reduce((a, b) => {
          //         return {target_qid: `${a.target_qid},${b.target_qid}`}
          //     }).target_qid.split(",");
          //     target_qid_arr.forEach(x => {
          //         let matchedIndex = _this.questionsAll.findIndex(q => q.qid == x)
          //         _this.questionsAll[matchedIndex].hide = true;
          //     })
          //   }
            _this.questions = JSON.parse(JSON.stringify(_this.questionsAll));

            let style = _this.baseStyle;

            if (style) {
                if (style.bgSrc) {
                    _this.style = Object.assign({}, {
                      backgroundImage: `url(${style.bgSrc})`,
                      backgroundSize: 'cover'
                    });
                } else if (style.color) {
                    _this.style = Object.assign({}, {
                      backgroundColor: style.color
                    });
                }
                if (style.textColor) {
                    _this.style = Object.assign({}, _this.style, {
                      color: style.textColor
                    });
                }
            }
            if(res.user) {
                _this.account = res.user.account;
                _this.starttime = res.user.starttime;
            }
            if(!_this.isInIFrame && (_this.base.logintype == 2 || _this.base.logintype == 5)) {
                let params = getUrlParams();
                return api.login(Object.assign(params, {
                  sid: this.$route.params.sid
                })).then(res => {
                  if(!res) return;
                  _this.account = res.data.account;
                  if (res.errors && res.errors.error_message) {
                      store.commit(types.SHOW_MODAL, {name: 'message', msg: res.errors.error_message[0]});
                      return;
                  }
                  if(res.replycount == 1) {
                      store.commit(types.SHOW_MODAL, {name: 'message', msg: `您已参加过该问卷调查哦，感谢您的参与~`});
                  }
                });
            }
          } catch (error) {

          }
      },
      itemContentUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.text = indexData.text;
                }
                return item;
              });
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item) => {
              item.text = indexData.text;
              return item;
            });
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      itemOnClick(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              let currentState = questionData.options.find((item, index) => index == indexData.index).selected;
              let selectedNum = questionData.options.filter(item => item.selected).length;
              if(!currentState && selectedNum === parseInt(questionData.maxnum)) {
                store.commit(types.SHOW_MODAL, {name: 'message', msg: `该题请至多选择${questionData.maxnum}项哦~`});
                return;
              }
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.selected = !item.selected;
                }
                return item;
              });
              this.resetQuestions(questionData, indexData.index);
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item, index) => {
              item.selected = index == indexData.index ? true : false;
              return item;
            });
            questionData.options.forEach((item, index) => {
                this.resetQuestions(questionData, index);
            })
          } else if(indexData.qtype == 6) {
              // 多选题
              questionData.rows[indexData.dIndex].val = indexData.index;
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
          console.log('questions', this.questions)
      },
      contentOnUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          questionData.content = indexData.content;
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      resetQuestions(src, index) {
        let _this = this;
        this.logics.forEach(item => {
            var targetOid = item.qoid.split(",")
            if(item.qid == src.qid && targetOid.includes(src.options[index].oid)) {
                let toBeDeletedQID = item.target_qid.split(',');
                toBeDeletedQID.forEach(x => {
                    let matchedIndex = _this.questionsAll.findIndex(q => q.qid == x)
                    let matchedOptions = src.options.filter(x => targetOid.includes(x.oid))
                    _this.questionsAll[matchedIndex].hide = matchedOptions.some(x => x.selected);
                });
            }
        })
      },
      checkForm() {
          for (let index = 0; index < this.questions.length; index++) {
              const element = this.questions[index];
              if(/^[1|4|5]/.test(element.qtype)) {
                  let matchedIndex = element.options.findIndex(item => item.selected);
                  if(element.required == 1) {
                      if(matchedIndex == -1) {
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: `请回答第${index + 1}题哦~`});
                          return false;
                      }
                      // 其他项必填且未填时，校验失败
                      if(element.options[matchedIndex].remark == 1 &&
                        element.options[matchedIndex].content_required == 1 &&
                        !element.options[matchedIndex].text
                      ) {
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: `请填写第${index + 1}题的第${matchedIndex + 1}个选项哦~`});
                          return false;
                      }
                  }
              } else if(/^2/.test(element.qtype)) {
                  let matchedItems = element.options.filter(item => item.selected);
                  if(element.required == 1) {
                      if(!matchedItems.length) {
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: `请回答第${index + 1}题哦~`});
                          return false;
                      }
                      if(matchedItems.length < parseInt(element.minnum)) {
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: `第${index + 1}题请至少选择${element.minnum}项哦~`});
                          return false;
                      }
                      if(matchedItems.length > parseInt(element.maxnum)) {
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: `第${index + 1}题请至多选择${element.maxnum}项哦~`});
                          return false;
                      }
                      for (let j = 0; j < matchedItems.length; j++) {
                          const ele = matchedItems[j];
                          // 其他项必填且未填时，校验失败
                          if(ele.remark == 1 &&
                              ele.content_required == 1 &&
                              !ele.text
                          ) {
                              store.commit(types.SHOW_MODAL, {name: 'message', msg: `请填写第${index + 1}题的选项哦~`});
                              return false;
                          }
                      }
                  }
              } else if(/^6/.test(element.qtype)) {
                  //TODO:
              } else if(element.required == 1) {
                  if(!element.content) {
                      store.commit(types.SHOW_MODAL, {name: 'message', msg: `请回答第${index + 1}题哦~`});
                      return false;
                  }
                  if((element.qtype == 3 || element.qtype == 307) &&
                    parseInt(element.alength) > 0 &&
                    element.content &&
                    this.getCharLength(element.content) > parseInt(element.alength)
                  ) {
                      store.commit(types.SHOW_MODAL, {name: 'message', msg: `第${index + 1}题超过字数限制哦`});
                      return false;
                  }
              }
          }
          return true;
      },
      submit() {
          if(!this.checkForm()) {
            //   store.commit(types.SHOW_MODAL, {name: 'message', msg: '请把表单填写完整哦~'});
              return;
          }
          let data = [];
          this.questions.forEach((x) => {
              if(/^[1|4|5]/.test(x.qtype)) {
                  let matchedItem = x.options.find(item => item.selected);
                  data.push({
                      qid: x.qid, oid: matchedItem.oid, content: matchedItem.remark == 1 ? matchedItem.text : matchedItem.content
                  });
              } else if (/^2/.test(x.qtype)) {
                  let matchedItems = x.options.filter(item => item.selected);
                  matchedItems.forEach(item => {
                      data.push({
                        qid: x.qid, oid: item.oid, content: item.remark == 1 ? item.text : item.content
                      });
                  });
              } else if (/^6/.test(x.qtype))  {
                  x.rows.forEach(item => {
                      if(item.val >= 0) {
                          data.push({
                            qid: x.qid,
                            rid: item.rid,
                            oid: x.options[item.val].oid
                          });
                      }
                  })
              } else {
                  data.push({
                      qid: x.qid,
                      content: x.content
                  });
              }
          });
          const deviceDetector = new DeviceDetector();
          const device = deviceDetector.parse(window.navigator.userAgent);
          if(device.device && device.device.model === 'LIO-AN00') {
              device.device.model = 'Mate 30 Pro(5G)'
          }
          api.submit(
              this.$route.params.sid,
              data,
              this.starttime,
              JSON.stringify(device)
          ).then(res => {
              if(res) {
                this.$refs["alert"].openModal(this.base.endmsg).then(() => {
                    if(res.redirecturl) {
                        location.href = res.redirecturl;
                    }
                    if(res.callbackmsg) {
                        redirectTo(res.callbackmsg)
                    }
                })
                console.log("surveyfinish");
              }
          });
      }
    }
  }
</script>
<style lang="stylus" scoped>
  /deep/.app
    width 100%
    height 100%
</style>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
    .pg-answer
        position relative
        width 100%
        height 100%
        font-size: 16px;
        .step1
          width 100%
          height 100vh
          background-color #e0edfe
          background-image url('./images/mbg.png')
          background-size contain
          background-repeat no-repeat
          background-position top center
          padding 30% 25px 0
          &.horizontal
            background-image url('./images/bg.png')
            background-size cover
            padding 10% 50px 0
          .TopBgTitle
              color: #484848;
              font-size: 28px;
              font-weight: 500;
              text-align center;
          .desc_begin
              font-size: 16px;
              line-height 1.5
              color: #484848;
              margin: 20px 0 0;
          .submmit
            position: absolute;
            bottom: 0.3rem;
            left: 50%;
            margin-left: -2.7rem;
            padding-bottom: calc(constant(safe-area-inset-bottom) + 0.3rem);
            padding-bottom: calc(env(safe-area-inset-bottom) + 0.3rem)/* 兼容 iOS < 11.2 */
        &.with-bg {
          padding 0.10rem;
        }
        .progress {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          padding: 5px 12px;
          background-color: #E3E3E5;
          z-index: 50;
          position: fixed;
          &-bar {
            flex: 1 1;
            height: 3px;
            background-color: #FFFFFF;
            border-radius: 3px;
            transform: translate3d(0, 0, 0);
            overflow: hidden;
          }
          &-done {
            width: 0;
            height: 100%;
            background-color: #008FFF;
            transition: 0.3s;
          }
        }
        .submmit
          margin 0.90rem auto 0
          width 5.40rem;
          text-align: center;
          text-decoration: none;
          color: #ffffff;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          border-radius: 6px;
          letter-spacing 0.10rem;
          cursor: pointer;
          background-color: #2672FF;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.07);
        .container
            width 100%
            height 100%
            min-height 100vh
            overflow-y scroll
            background-color #e0edfe
            .survey_cover_text
                margin: 0 0.50rem;
                padding: 0.30rem 0 0.12rem;
                background-color: transparent;
                box-shadow: none;
                .wjhr
                    background-color: #53a4f4!important;
                    width: 100%;
                    height: 0.03rem;
                    margin-top: 0.20rem;
                .user {
                    float right
                    font-size: 0.20rem;
                    margin-top  0.20rem
                    .username {
                        margin-right 0.10rem
                    }
                    i {
                        &:hover {
                            color red
                        }
                    }
                }
            .questions
                width 100%
                display flex
                flex-direction column
                justify-content center
            .tail
                height 0.30rem;
                width 100%
</style>
